import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Navigate } from '~/utils/navigation';
import Cookies from '@comeon/tomcat-cookies';
import { generatePostAuthLocation } from '~/components/authentication';
import { setPostAuthLocation } from '~/components/authentication/ducks';
import { postAuthLocationSelector } from '~/components/authentication/ducks/selectors';
import { selectDefaultProduct } from '~/components/brand/ducks/selectors';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { ROUTE_LOGIN } from '~/components/router/constants';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';
import useBasePathname from '~/hooks/use-base-pathname';
import { PlayNow } from './async';
import {
	selectOneBankIDFlowEnabled,
	selectOneButtonFlowEnabled
} from '~/store/feature-toggles/onboarding-feature-toggles';

const PlaynowGateway = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const transformPath = useContextualPathTransformer();
	const postAuthLocation = useSelector(postAuthLocationSelector);
	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlowEnabled);
	const smaller = useSelector(isSmallerSelector);
	const defaultProduct = useSelector(selectDefaultProduct);
	const basePathname = useBasePathname(defaultProduct);

	useEffect(() => {
		if (oneBankIDFlowEnabled || oneButtonFlow) {
			const storedLocation = Cookies.getJSON('postAuthLocation');

			const authLocation =
				postAuthLocation ??
				storedLocation ??
				generatePostAuthLocation(location, smaller, transformPath, basePathname);

			dispatch(setPostAuthLocation(authLocation));

			if (storedLocation === authLocation) {
				Cookies.remove('postAuthLocation');
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!oneBankIDFlowEnabled && !oneButtonFlow) {
		// TODO (navigation) - use search params or redux for state
		return (
			<Navigate
				to={{
					pathname: ROUTE_LOGIN
				}}
				state={{
					from: location,
					implicit: true
				}}
			/>
		);
	}

	return <PlayNow />;
};

export default PlaynowGateway;
